import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { PageHeader } from "@/shared/components/PageHeader";
import { PositionFormModal } from "../components/PositionFormModal";
import { PositionTable } from "../components/PositionTable";
import { usePositionsStore } from "../store/positions.store";

export function OrganizationTypePositionsPage() {
	const onOpen = usePositionsStore((s) => s.onOpen);

	return (
		<div>
			<PageHeader
				title="Lavozimlar"
				action={
					<Button
						type="primary"
						icon={<PlusOutlined />}
						onClick={() => onOpen()}
						id="positions-create-btn"
					>
						Qo&apos;shish
					</Button>
				}
			/>
			<PositionTable />
			<PositionFormModal />
		</div>
	);
}
